import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminLayout, { scoreColor } from "./AdminLayout";
import api from "../../lib/api";

const ROWS = [
  ["total_score","Total Score"],["ethnic_food","Ethnic Food Experience"],["irish_market","Irish Market Experience"],
  ["new_business","New Business"],["network","Customer Network"],["commercial","Commercial Skills"],
  ["distributor","Distributor Experience"],["territory","Territory Experience"],["eligibility","Eligibility"],
  ["expected_salary","Expected Salary"],["notice_period","Notice Period"],
];

export default function Compare() {
  const loc = useLocation();
  const navigate = useNavigate();
  const ids = loc.state?.ids || [];
  const [cands, setCands] = useState([]);

  useEffect(() => {
    if (!ids.length) return;
    api.post("/admin/compare", { application_ids: ids }).then(({ data }) => setCands(data.candidates));
  }, []); // eslint-disable-line

  if (!ids.length) return <AdminLayout title="Compare Candidates"><p className="text-muted-foreground">Select candidates from the Analysis page to compare. <button className="text-[#8a6a1e] hover:underline" onClick={() => navigate("/admin/analysis")}>Go to Analysis →</button></p></AdminLayout>;

  return (
    <AdminLayout title="Side-by-Side Comparison">
      <div className="bg-white rounded-lg border border-[#E4C675]/50 shadow-sm overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#101820] text-[#E4C675]">
              <th className="px-4 py-3 text-left sticky left-0 bg-[#101820]">Criterion</th>
              {cands.map((c) => <th key={c.application_id} className="px-4 py-3 text-center min-w-[160px]">{c.name}<div className="text-[10px] text-[#C79A3B] font-normal">{c.match_label}</div></th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-[#C79A3B]/10">
            {ROWS.map(([key, label]) => (
              <tr key={key} className={key === "total_score" ? "bg-[#FAF6EE] font-semibold" : ""}>
                <td className="px-4 py-2.5 text-[#101820] sticky left-0 bg-inherit font-medium">{label}</td>
                {cands.map((c) => (
                  <td key={c.application_id} className="px-4 py-2.5 text-center">
                    {key === "total_score" ? <span className={`inline-block font-mono-data font-bold px-2.5 py-1 rounded-md border ${scoreColor(c[key])}`}>{c[key]}</span>
                      : typeof c[key] === "number" ? <span className="font-mono-data">{c[key]}</span> : (c[key] || "—")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cands.map((c) => (
          <div key={c.application_id} className="bg-white rounded-lg border border-[#E4C675]/50 shadow-sm p-5">
            <h3 className="font-heading font-bold text-[#101820]">{c.name}</h3>
            <div className="mt-1 text-xs text-[#8a6a1e] font-semibold">{c.recommended_action}</div>
            <div className="mt-3"><div className="text-xs uppercase tracking-wider text-[#2E7D32] font-semibold">Strengths</div><ul className="list-disc list-inside text-sm text-[#101820]/80 mt-1">{(c.strengths||[]).map((s,i)=><li key={`${c.application_id}-s-${i}-${s}`}>{s}</li>)}</ul></div>
            <div className="mt-3"><div className="text-xs uppercase tracking-wider text-[#C76A32] font-semibold">Gaps</div><ul className="list-disc list-inside text-sm text-[#101820]/80 mt-1">{(c.gaps||[]).map((s,i)=><li key={`${c.application_id}-g-${i}-${s}`}>{s}</li>)}</ul></div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
